import { cn } from "@/components/podkit/lib/cn";
import type React from "react";

type Props = {
    children: React.ReactNode;
    className?: string;
};
export function KeyboardKey({ children, className }: Props) {
    return (
        <kbd
            className={cn(
                // Using box-shadow for the border as it is more versatile when rendered on different backgrounds, e.g.
                // if a background changes on hover.
                "rounded bg-surface-accent shadow-none",
                "my-0.5 h-5 px-1.5 text-center font-sans text-[12px] capitalize leading-5",
                // Override colors when inside a Tooltip (which has group and data-component="tooltip")
                "group-data-[component=tooltip]:bg-surface-accent-always-dark group-data-[component=tooltip]:text-content-always-white",
                className,
            )}
        >
            {children}
        </kbd>
    );
}
